import { HStack } from "@chakra-ui/react-v3";

import { Skeleton } from "./Skeleton";

// Varied widths read as tab labels rather than a row of identical bars.
const TAB_WIDTHS = ["24", "32", "20"] as const;

export type TabsSkeletonProps = {
  /** Number of tab placeholders. */
  tabs?: number;
};

/**
 * Placeholder for a row of tabs whose labels depend on data that has not
 * loaded yet. Covers the tab row only; render the active panel's placeholder
 * below it.
 */
export function TabsSkeleton(props: TabsSkeletonProps) {
  const { tabs = 3 } = props;

  return (
    <HStack gap="2">
      {Array.from({ length: tabs }, (_, tab) => (
        <Skeleton
          key={tab}
          height="8"
          width={TAB_WIDTHS[tab % TAB_WIDTHS.length]}
        />
      ))}
    </HStack>
  );
}
